export const tabs = [
    {
        name: '7 dias',
        active: true,
        value: 7
    },
    {
        name: '15 dias',
        active: false,
        value: 15
    },
    {
        name: '30 dias',
        active: false,
        value: 30
    },
    {
        name: 'todos',
        active: false,
        value: 0
    }
];
